import { Text } from "@mantine/core"
import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { useMemo } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { DateCell } from "~/components/cells/DateCell"

export const useGetExportColumns =
  (): ColumnDef<AdminResponses.BouncedEmails>[] => {
    const columnHelper = createColumnHelper<AdminResponses.BouncedEmails>()

    return useMemo<ColumnDef<AdminResponses.BouncedEmails, any>[]>(
      () => [
        columnHelper.accessor("createdAt", {
          enableSorting: false,
          header: "Date",
          cell: ({ getValue }) => <DateCell date={getValue()} />,
        }),
        columnHelper.accessor("inviterCompany", {
          enableSorting: false,
          header: "Inviter Company",
          cell: ({ getValue }) => <Text>{getValue()}</Text>,
        }),
        columnHelper.accessor("inviterEmail", {
          enableSorting: false,
          header: "Inviter Email",
          cell: ({ getValue }) => <Text>{getValue()}</Text>,
        }),
        columnHelper.accessor("event", {
          enableSorting: false,
          header: "Event",
          cell: ({ getValue }) => <Text>{getValue()}</Text>,
        }),
        columnHelper.accessor("supplierEmail", {
          enableSorting: false,
          header: "Supplier Email",
          cell: ({ getValue }) => <Text>{getValue()}</Text>,
        }),
      ],
      [columnHelper]
    )
  }
